var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Usuarios y Mensajes Reportados","storeName":"User_reports","labelAddNew":"Agregar","sortable":"","canSearch":"","canAdd":false,"canEdit":false,"canDelete":true,"next-link":"/admin/notifications_cms","breadcrumbs":[
    {
      text: 'Gestion de usuarios',
      disabled: false,
      href: '/admin/users_scroll'
    },
    {
      text: 'Usuarios y Mensajes Reportados',
      disabled: false,
      href: '#'
    }
  ]},scopedSlots:_vm._u([{key:"item.user_id.fullname",fn:function({ item }){return [_vm._v(" "+_vm._s(item.user_id?.fullname || 'N/A')+" ")]}},{key:"item.reported_by_user_id.fullname",fn:function({ item }){return [_vm._v(" "+_vm._s(item.reported_by_user_id?.fullname || 'N/A')+" ")]}},{key:"item.conversation_id.status",fn:function({ item }){return [_c('span',{class:[
        'status-chip',
        item.conversation_id?.status === 'active'
          ? 'active'
          : 'finished'
      ]},[_vm._v(" "+_vm._s(item.conversation_id?.status || 'N/A')+" ")])]}},{key:"created_at",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.formatDate(item.created_at))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }